import {registerMiddleware} from '@homeaway/redux-middleware-adapter';

import {checkStatus} from '../utils/api';
import actions from './actions';
import {API} from '../routes.js';

function doRecentActivityFetch(store) {
    store.dispatch(actions.fetchRecentActivityStart());

    fetch(`${API}/recent-activity/fullV1`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'GET',
        credentials: 'include'
    })
    .then(checkStatus)
    .then((r) => r.json())
    .then((recentActivity) => {
        store.dispatch(actions.fetchRecentActivitySuccess(recentActivity));
    })
    .catch((error) => {
        store.dispatch(actions.fetchRecentActivityError(error));
    });
}

function registerAllMiddleware() {
    registerMiddleware(actions.FETCH_RECENT_ACTIVITY, doRecentActivityFetch);
}

export default registerAllMiddleware;



// WEBPACK FOOTER //
// ./src/universal/recent-activity/middleware.js